import LegalLayout, { COMPANY, EMAIL } from "./LegalLayout";

export default function Contact() {
  return (
    <LegalLayout title="Soporte y Contacto">
      <p>¿Necesitas ayuda con Hephy 3D? Estamos para apoyarte.</p>

      <h2>Correo de soporte</h2>
      <p><a href={`mailto:${EMAIL}`} data-testid="contact-email">{EMAIL}</a></p>
      <p>Respondemos normalmente en un plazo de 1–2 días hábiles.</p>

      <h2>Con qué podemos ayudarte</h2>
      <ul>
        <li>Configuración inicial (onboarding) y creación de la versión 3D de tus productos.</li>
        <li>Integraciones con Wix y Shopify.</li>
        <li>Facturación, planes y comisiones.</li>
        <li>Problemas técnicos del visor 3D o del personalizador.</li>
      </ul>

      <h2>Empresa</h2>
      <p>{COMPANY} · Estados Unidos</p>
    </LegalLayout>
  );
}
